var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDianZan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 23.999250411987305,
    height: 23.943618774414062,
    viewBox: "0 0 23.999250411987305 23.943618774414062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_7_01364"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.999250411987305,
    height: 23.943618774414062,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_7_01364)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.4992504119873047,11.32284125L1.4992504119873047,20.43908125C1.4992504119873047,21.31138125,2.205750411987305,22.01788125,3.078000411987305,22.01788125L4.499250411987305,22.01788125L4.499250411987305,9.75909125L3.078000411987305,9.74409125C2.2060804119873048,9.74409125,1.4992504119873047,10.45092125,1.4992504119873047,11.32284125ZM20.091750411987306,8.08734125L13.815050411987304,8.12709125C14.109750411987305,7.08984125,14.259050411987305,6.16809125,14.259050411987305,5.35659125C14.259050411987305,3.51534125,12.645750411987304,1.71233725,11.034750411987305,1.94633735C9.614250411987305,2.15258725,9.458250411987304,3.38034125,9.458250411987304,4.91859125L9.458250411987304,6.30759125C9.458250411987304,8.09034125,7.9620004119873045,9.609091249999999,6.2272504119873044,9.77634125L5.999250411987305,9.77409125L5.999250411987305,22.01788125L18.363750411987304,22.01788125C19.520450411987305,22.01788125,20.513750411987306,21.19528125,20.729250411987305,20.05888125L22.457250411987303,10.94259125C22.737950411987306,9.45980125,21.600850411987306,8.08734125,20.091750411987306,8.08734125Z",
    fill: "#2588F8",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDianZan);
export default __webpack_public_path__ + "static/media/dianZan.4f2a808cd56e77148444cd526a15c13c.svg";
export { ForwardRef as ReactComponent };